// extracted by mini-css-extract-plugin
export var bounce = "_jx-1";
export var generatingText = "_jx-6";
export var lightning = "_jx-4";
export var popup = "_jx-5";
export var progressBar = "_jx-7";
export var progressFill = "_jx-8";
export var progressShimmer = "_jx-9";
export var progressText = "_jx-a";
export var shimmer = "_jx-3";
export var uploadIcon = "_jx-0";
export var uploadingText = "_jx-2";